package com.merkost.handpass.api.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class AdminRole(val value: String) {
    @SerialName("moderator") MODERATOR("moderator"),
    @SerialName("admin") ADMIN("admin"),
    @SerialName("super_admin") SUPER_ADMIN("super_admin");

    fun isAtLeast(min: AdminRole): Boolean = ordinal >= min.ordinal

    companion object {
        fun fromDbValue(value: String): AdminRole =
            entries.find { it.value == value } ?: MODERATOR
    }
}
